import Button from '@mui/material/Button';
import { HSpacer, RoutalPalette } from '@nx-smartmonkey/ui';
import { Text } from '../../../../../../../../react-components/Text';
import { RouteFooterContainer } from '../../../../route-stops-footers/RouteFooterContainer';

interface TaskFooterButtonProps {
  disabled?: boolean;
  containerStyle?: React.CSSProperties;
  buttonStyle?: React.CSSProperties;
  buttonColor: string;
  buttonIntlId?: string;
  buttonTextColor?: string;
  children?: React.ReactNode;
  image?: string;
  onClick?: () => void;
}

export const TaskFooterButton = ({
  disabled,
  children,
  containerStyle,
  buttonStyle,
  buttonColor,
  buttonIntlId,
  buttonTextColor = RoutalPalette.white,
  image,
  onClick,
}: TaskFooterButtonProps) => {
  return (
    <RouteFooterContainer style={{ ...containerStyle, cursor: disabled ? `default` : `pointer` }}>
      <Button
        style={{
          width: `100%`,
          height: `50px`,
          backgroundColor: buttonColor,
          borderRadius: `10px`,
          textTransform: `none`,
          ...buttonStyle,
        }}
        disabled={disabled}
        onClick={() => {
          onClick && onClick();
        }}
      >
        {children ? (
          children
        ) : buttonIntlId ? (
          <Text variant="body-large" style={{ color: buttonTextColor }} intlId={buttonIntlId} />
        ) : null}

        {image && (
          <>
            <HSpacer small />
            <img src={image} style={{ width: `20px`, height: `auto` }} alt="footer" />
          </>
        )}
      </Button>
    </RouteFooterContainer>
  );
};
